export function getConvexBaseUrl() {
  // HTTP actions (including logo endpoints) live on the Convex "site" URL.
  // IMPORTANT: Use import.meta.env.VITE_* directly (not via `as any`) so
  // Vite statically replaces the values at build time.
  return (
    import.meta.env.VITE_CONVEX_SITE_URL ||
    import.meta.env.VITE_CONVEX_URL ||
    "http://localhost:3211"
  );
}

export function getBrandLogoUrl(kind: "primary" | "square" = "primary") {
  const base = String(getConvexBaseUrl()).replace(/\/$/, "");
  const updatedAt = (window as any).__jourfxBrandingUpdatedAt || 0;
  const path = kind === "primary" ? "/api/branding/logo-primary" : "/api/branding/logo-square";
  return `${base}${path}?v=${updatedAt}`;
}
